export default __webpack_public_path__ + "static/media/logo.3fad7fb1.png";